import cargas_services_tpa from '../cargas_services_tpa'

const api_cargas_tpa = {}


api_cargas_tpa.getCargasTPA = async function (form) {

  const options = {
    method: 'POST',
    url: '/api/getCargasTPA',
    headers: {'Content-Type': 'application/json'},
    data: form
  }

  const data = await cargas_services_tpa(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

api_cargas_tpa.getCargasFaltantesTPA = async function (form) {

  const options = {
    method: 'POST',
    url: '/api/getFaltantesTPA',
    headers: {'Content-Type': 'application/json'},
    data: form
  }

  
  const data = await cargas_services_tpa(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

export default api_cargas_tpa


// WEBPACK FOOTER //
// ./src/services/sca/apiCargasTpa.js